<div
  class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container gap-3 flex flex-col">
  <h1 class="text-headline-sm-weight-medium text-container-fg-default text-[1.125rem]">
    Distribution
  </h1>

  <div class="flex gap-x-025-rem items-center">
    <i
      class="icon_marina_ui_InfoOutlined text-container-fg-muted text-headline-sm"
      aria-hidden="true"></i>
    <p class="text-container-fg-muted text-body-lg-weight-regular">
      Distribution information is inherited from the selected firmware package (read-only).
    </p>
  </div>

  <form class="space-y-100-rem">
    <p class="text-label-lg-weight-medium">Allowed to install by</p>
    <div class="opacity-45">
      <mat-button-toggle-group
        name="mat-button-toggle-group"
        aria-label="access"
        [disabled]="true"
        [value]="formattedAccess()">
        <mat-button-toggle value="Update by CPO">Update by CPO</mat-button-toggle>
        <mat-button-toggle value="Update by CPO & end-user">Update by CPO & user</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div>
      <p class="text-label-lg-weight-medium">Installable via</p>

      @for(appDetails of companionAppDetails(); track appDetails.name){
      <div class="grid grid-cols-3 space-y-150-rem">
        <mat-checkbox [checked]="appDetails.name.length > 0" [disabled]="true">
          {{ appDetails.name }}
        </mat-checkbox>
        <div>
          <p class="text-label-sm-weight-regular text-container-fg-muted">iOS minimum version</p>
          <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
            {{ appDetails.appleMinimumVersion }}
          </p>
        </div>

        <div>
          <p class="text-label-sm-weight-regular text-container-fg-muted">
            Android minimum version
          </p>
          <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
            {{ appDetails.androidMinimumVersion }}
          </p>
        </div>
      </div>
      }
    </div>
  </form>
</div>
